import { useCallback, useState } from "react";
import { isServerSide } from "app/utils/utils";

const readDesignMode = (): boolean => {
	if (isServerSide) {
		return false;
	}

	return document.designMode === "on";
};

/**
 * Toggles the browser design mode and exposes whether it is currently active.
 */
export const useDesignMode = () => {
	const [isActive, setActive] = useState(readDesignMode);

	const toggle = useCallback(() => {
		const next = !readDesignMode();
		document.designMode = next ? "on" : "off";
		setActive(next);
	}, []);

	return { isActive, toggle };
};
